var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation } from 'react-apollo';
import subscribeToStockNotificationsMutation from '@jetshop/core/data/mutations/subscribeToStockNotifications.gql';
import { useStoreSubscriptions } from './useStoreSubscriptions';
function useStockNotifications({ articleNumber, enabled = false }) {
    var _a;
    const [subscribeMutation] = useMutation(subscribeToStockNotificationsMutation);
    const _b = useStoreSubscriptions({
        services: { trySubmit },
        enabled
    }), { fields, input } = _b, rest = __rest(_b, ["fields", "input"]);
    function trySubmit() {
        return new Promise((resolve, reject) => {
            return subscribeMutation({
                variables: {
                    articleNumber,
                    email: fields.email
                }
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }
    const inputProps = Object.assign(Object.assign({}, input), { name: 'email', value: (_a = fields.email) !== null && _a !== void 0 ? _a : '' });
    return Object.assign(Object.assign(Object.assign({}, fields), rest), { inputProps });
}
export { useStockNotifications };
//# sourceMappingURL=useStockNotifications.js.map